import React from "react";
import { SectionHeader } from "../../common/SectionHeader";
import { SectionContent } from "../../common/SectionContent";
import { SubSectionHeader } from "../../common/SubSectionHeader";
import { ImageContainer } from "../../common/ImageContainer";

export const ConfigureDataSource = () => {
  return (
    <React.Fragment>
      <SectionHeader title="CONFIGURE DATA SOURCE">
        <SectionContent>
          <p>{`This is where you can access your information that is currently 
          stored elsewhere and import it into Seqnc. Use 'Connect applications'
          for integrating real time account with your Seqnc account.`}</p>
          <p>
            Ensure you have connected to at least one real-time accounting
            application before configuring data sources.
          </p>
        </SectionContent>
      </SectionHeader>
      <SubSectionHeader
        title="CONNECT APPLICATION"
        id="connectApplication"
      >
        <SectionContent>
          <ImageContainer
            fileName="connectApplication.png"
            alt="connect application"
          />
          <p>
            Utilize this to configure the data source for your real-time
            accounting application.
          </p>
          <p>{`Use the ‘Authorize’ link to authorize a real time data source.`}</p>
          <p>
            <strong>Note:</strong> Reauthorizing with the same company updates the existing
            data source. Selecting a different company creates a new data source.
          </p>

        </SectionContent>
      </SubSectionHeader>

      <SubSectionHeader
        title="SET DEFAULT COMPANY"
        id="setDefaultCompany"
      >
        <SectionContent>
          <ImageContainer
            fileName="setdefaultcompany.png"
            alt="Set default company"
          />
          <p>
            The connected accounting application and its authorized companies are displayed here.
            Select a company from the 'Select for Mapping' dropdown to set it as the default for data
            mapping.</p>
        </SectionContent>
      </SubSectionHeader>
      <SubSectionHeader title="SELECT DATA SOURCE" id="selectDataSource">
        <SectionContent>
          <ImageContainer
            fileName="dsMappings1.png"
            alt="Select data source"
          />
          <p>{`Forecast to actual reports are categorized into ‘P_L’ and ‘Balance Sheet’. 
              Select the data source for each these categories for mapping the line items from the respected data source.`}</p>
          <p>{`Apart from the real time data source choose the ‘Manual’ option which allows to enter the actual values in the Forecast to Actual reports. If not mapped default setting would be manual.`}</p>
        </SectionContent>
      </SubSectionHeader>
      <SubSectionHeader title="CHANGE FIELD MAPPINGS" id="changeFieldMappings">
        <SectionContent>
          <ImageContainer
            fileName="changeFieldMappings.png"
            alt="Change field mappings"
          />
          <p>{`This feature will be enabled if the mapped data source for the report category is not ‘Manual’.`}</p>
          <p>{`In this section Seqnc accounts can be mapped to accounts retrieved from Third party data sources. Values from mapped accounts will be used for comparison.`}</p>
          <p>{`Please note that we don't allow mapping on both parent and child items at the same time.So You can either map to a parent item or map to children but not both .`}</p>
        </SectionContent>
      </SubSectionHeader>
    </React.Fragment>
  );
};
